import React, { useState } from 'react';
import { Button, Checkbox, Text, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../constants/cypressIds';
import colors from '../../../styles/theme/foundation/colors';

const ConfirmDontAskAgainButtons = ({
  label = 'Confirm',
  onClick,
  cookieId,
  isLoading
}) => {
  const [checked, setChecked] = useState(false);

  const handleClick = () => {
    onClick();
    if (checked) document.cookie = `${cookieId}=true`;
  };

  return (
    <VStack height="inherit" spacing={4} width="100%">
      <Button
        isRound
        data-cy={CypressIds.confirmDontAskAgainButton}
        dusk="confirm-dont-ask-again-button"
        isLoading={isLoading}
        size="lg"
        variant="gradientSuccess"
        width="180px"
        onClick={handleClick}
      >
        {label}
      </Button>
      <Checkbox
        color={colors.greyScale['500']}
        fontSize="sm"
        fontWeight="medium"
        isDisabled={isLoading}
        onChange={() => setChecked(!checked)}
      >
        <Text textStyle="bodyMd500"> Don&apos;t ask me again</Text>
      </Checkbox>
    </VStack>
  );
};

/** Only used with training modals or actions that can be reversed.
 * Before dispatching the modal from your parent component, check for the cookie id
 * */
ConfirmDontAskAgainButtons.propTypes = {
  /** Text displayed on button. Defaults to 'Confirm' */
  label: PropTypes.string,
  /** Event handler for button */
  onClick: PropTypes.func.isRequired,
  /** ID or name of cookie. Will set as `key=value` pair `cookieId=true` */
  cookieId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool
};

export default ConfirmDontAskAgainButtons;
